import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditClientVm {
	clientId: number;
	clientName?: string;
	letterCodes?: number[];

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'clientId': new UntypedFormControl(0, [...(validators['clientId'] ?? []), ...[Validators.required]]),
			'clientName': new UntypedFormControl(null, [...(validators['clientName'] ?? []), ...[Validators.required, Validators.minLength(2), Validators.maxLength(100)]]),
			'letterCodes': new UntypedFormControl([], [...(validators['letterCodes'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): EditClientVmFromFg {
		return new EditClientVmFromFg(fg);
	}
}

export class EditClientVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get clientId(): number {
		return this.fg.get('clientId').value;
	}
	set clientId(val) {
		this.fg.get('clientId').setValue(val);
	}

	get clientName(): string {
		return this.fg.get('clientName').value;
	}
	set clientName(val) {
		this.fg.get('clientName').setValue(val);
	}
}
